// extracted by mini-css-extract-plugin
module.exports = {"tidyList":"IconsList_tidyList__9Ewas","middleApp":"IconsList_middleApp__2__FP","placeholderApp":"IconsList_placeholderApp__CvUOk"};